import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function JiraConnectForm({ onSubmit, guideMode }) {
  const [showToken, setShowToken] = useState(false);
  const handleClickShowToken = () => setShowToken(!showToken);
  const handleMouseDownShowToken = () => setShowToken(!showToken);
  const formInitialValues = {
    organizationUrl: "",
    email: "",
    token: "",
  };
  const formCheckoutSchema = yup.object().shape({
    organizationUrl: yup.string().required("required"),
    email: yup.string().email().required("required"),
    token: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  const jiraTokenUrl = "https://id.atlassian.com/manage/api-tokens";

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="organizationUrl"
                label="Jira Organization Url"
                value={values.organizationUrl}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.organizationUrl && !!errors.organizationUrl}
                helperText={touched.organizationUrl && errors.organizationUrl}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="email"
                label="User Email"
                value={values.email}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.email && !!errors.email}
                helperText={touched.email && errors.email}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="token"
                label="Token"
                value={values.token}
                type={showToken ? "text" : "password"}
                onBlur={handleBlur}
                onChange={handleChange}
                autoComplete="off"
                error={!!touched.token && !!errors.token}
                helperText={touched.token && errors.token}
                InputProps={{
                  // <-- This is where the toggle button is added.
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowToken}
                        onMouseDown={handleMouseDownShowToken}
                      >
                        {showToken ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                infoText={
                  /* eslint-disable-next-line */
                  <a
                    target="_blank"
                    onClick={() => window.open(jiraTokenUrl, "_blank")}
                  >
                    Get Jira token
                  </a>
                }
                disabled={guideMode}
              />
            </Box>
            <Box width={700} display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
